export default "__VITE_ASSET__37b26618__"